// 登录接口
import {
	axios
} from '@/utils/http.js'

const CompanyApi = {
	CompanyTree: '/v3/Company/Tree',//列表树
	CompanyDel: '/v3/Company/Del',//删除公司
	CompanyEdit: '/v3/Company/Edit',//编辑公司
	CompanyAdd: '/v3/Company/Add',//添加公司
	CompanyEntry: '/v3/Company/Entry',//进入公司
	dataTwin: '/v3/Company/DigitalTwin',//数据孪生
	dataPay: '/v3/Company/Pay',//充值
	dataWarning: '/v3/Company/Warning',//充值
	dataCharging: '/v3/Company/Charging',//充值
	ThirdPartiesSkip: '/v3/Company/ThirdPartiesSkip',//第三方跳转
    CompanyDetails: '/v3/Company/Details',//详情
    expires:'/v3/Company/ExpirationTime',//合同到期
    GetCompanyInfo:'/v3/User/GetCompanyInfo',//获取公司信息
    _userGet:'/v3/User/Get',

}
export function _userGet(data) {
	return axios({
		url:CompanyApi._userGet,
		method: 'post',
		data:data
	})
}
//获取公司信息
export function GetCompanyInfo(data) {
	return axios({
		url:CompanyApi.GetCompanyInfo,
		method: 'post',
		data:data
	})
}
//设置合同到期
export function contractExpires(data) {
	return axios({
		url:CompanyApi.expires,
		method: 'post',
		data:data
	})
}
//详情
export function CompanyDetails(data) {
	return axios({
		url: CompanyApi.CompanyDetails,
		method: 'post',
		data:data
	})
}
//第三方跳转
export function ThirdPartiesSkip(data) {
	return axios({
		url: CompanyApi.ThirdPartiesSkip,
		method: 'post',
		data:data
	})
}
//充值
export function dataCharging(data) {
	return axios({
		url: CompanyApi.dataCharging,
		method: 'post',
		data:data
	})
}
//充值
export function dataWarning(data) {
	return axios({
		url: CompanyApi.dataWarning,
		method: 'post',
		data:data
	})
}
//充值
export function dataPay(data) {
	return axios({
		url: CompanyApi.dataPay,
		method: 'post',
		data:data
	})
}
//数据孪生
export function dataTwin(data) {
	return axios({
		url: CompanyApi.dataTwin,
		method: 'post',
		data:data
	})
}
//进入公司
export function CompanyEntry(data) {
	return axios({
		url: CompanyApi.CompanyEntry,
		method: 'post',
		data:data
	})
}
//添加公司
export function CompanyAdd(data) {
	return axios({
		url: CompanyApi.CompanyAdd,
		method: 'post',
		data:data
	})
}
//编辑公司
export function CompanyEdit(data) {
	return axios({
		url: CompanyApi.CompanyEdit,
		method: 'post',
		data:data
	})
}
//删除公司
export function CompanyDel(data) {
	return axios({
		url: CompanyApi.CompanyDel,
		method: 'post',
		data:data
	})
}
//列表
export function CompanyTree(data) {
	return axios({
		url: CompanyApi.CompanyTree,
		method: 'post',
		data:data
	})
}
